import { Injectable } from '@angular/core';
import swal, { SweetAlertCustomClass, SweetAlertIcon, SweetAlertOptions, SweetAlertResult } from 'sweetalert2';
export { SweetAlertResult } from 'sweetalert2';
declare var $: any;

@Injectable({ providedIn: 'root' })
export class SweetAlert2Service {

  constructor() {
  }
  showConfirm(title: string, html: string, icon: SweetAlertIcon, showCancel = true,showConfirm = true, ): Promise<SweetAlertResult>{
    return swal.fire({
      title,
      html,
      icon,
      showConfirmButton: showConfirm,
      showCancelButton: showCancel,
    });
  }

  showSwal(title: string, html: string, icon: SweetAlertIcon | null,
    showCancelButton: boolean = false,
    customClass: SweetAlertCustomClass,
    confirmButtonText: string,
    cancelButtonText: string,
    showCloseButton: boolean = true,
    buttonsStyling: boolean = false,
    backdrop: boolean | string = 'rgba(0, 0, 0, 0.37);',
    ): Promise<SweetAlertResult>{
    return swal.fire({
      title,
      //text,
      html,
      icon,
      showCancelButton,
      showCloseButton,
      customClass,
      confirmButtonText,
      cancelButtonText,
      buttonsStyling,
      backdrop,
    });
  }

  showSwalInput(title: string, html: string, icon: SweetAlertIcon | null,
    showCancelButton: boolean = false,
    customClass: SweetAlertCustomClass,
    confirmButtonText: string,
    cancelButtonText: string,
    showCloseButton: boolean = true,
    buttonsStyling: boolean = false,
    backdrop: boolean | string = 'rgba(0, 0, 0, 0.37);',
    ): Promise<SweetAlertResult>{
    return swal.fire({
      title,
      //text,
      html,
      icon,
      showCancelButton,
      showCloseButton,
      customClass,
      confirmButtonText,
      cancelButtonText,
      buttonsStyling,
      backdrop,
      input:"text",
      inputPlaceholder:"Comments"
    });
  }

  showSwalWithOpts(opts: SweetAlertOptions): Promise<SweetAlertResult>{
    return swal.fire(opts);
  }

}
